import React from 'react';
import UserFormPage from "../UserFormPage";
import UserShowPage from "../UserShowPage";
export function usersRoutes({ authenticityToken }) { return [{ path: '/users/:id/edit', element: /*#__PURE__*/ React.createElement(UserFormPage, { authenticityToken: authenticityToken }) }, { path: '/users/:id', element: /*#__PURE__*/ React.createElement(UserShowPage, null) }]; }
